import ApiService from '@/api/service';
import {
  FETCH_DEVICES_URL,
  CREATE_DEVICE_URL,
  FETCH_SINGLE_DEVICE_URL,
  UPDATE_SINGLE_DEVICE_URL,
  DELETE_DEVICE_URL,
  UPDATE_REFRESH_RATE_URL,
  FETCH_DEVICE_USAGE_URL
} from '@/api/constants';

export default {
  query(params) {
    return ApiService.query(FETCH_DEVICES_URL, params);
  },
  getOne(params) {
    return ApiService.query(FETCH_SINGLE_DEVICE_URL, params);
  },
  updateOne(params) {
    return ApiService.put(UPDATE_SINGLE_DEVICE_URL, params);
  },
  updateRefreshRate(deviceId, refreshRate) {
    return ApiService.patch(
      UPDATE_REFRESH_RATE_URL
        .replace(':deviceId', deviceId)
        .replace(':value', refreshRate)
    )
  },
  create(params) {
    return ApiService.post(CREATE_DEVICE_URL, params);
  },
  deleteOne(deviceId) {
    return ApiService.delete(DELETE_DEVICE_URL.replace(':deviceId', deviceId));
  },
  getDeviceUsage(params) {
    return ApiService.query(FETCH_DEVICE_USAGE_URL, params);
  }
}